import type { RootStateOrAny } from 'react-redux'
import { useSelector } from 'react-redux'

import type { NumberOfPortions } from 'routes/Menu/domains/basket'
import { getNumPortions } from 'selectors/basket'

export const useNumPortions = () => {
  const numPortions = useSelector<RootStateOrAny, NumberOfPortions>(getNumPortions)

  return { numPortions }
}
